import { BaseDataTransferObject } from '../../../shared/models/base-data-transfer-object';
import { ClinicalResult, MicrobiologyResult, ToxicologyResult } from './results';


export class OrderPatientInformation extends BaseDataTransferObject {
    public patientId?: number;
    public patientFirstName?: string;
    public patientMiddleName?: string;
    public patientLastName?: string;
    public patientBirthDate?: Date;
    public patientAddress?: string;
    public patientZipCode?: string;
    public patientCity?: string;
    public patientState?: string;
    public patientGender?: string;
    public patientPhone?: string;
}

export class CumulativeResultsCollection {
    public collectionDate?: Date;
    public orders?: CumulativeOrderWrapper[];
}

export class CumulativeOrderWrapper extends BaseDataTransferObject{
    public code?: string;
    public date?: Date;
    public results?: ClinicalResult[] | MicrobiologyResult[] | ToxicologyResult[];
}
